import { render, staticRenderFns } from "./lkuBudgetproduksi.vue?vue&type=template&id=bd07dbf4"
import script from "./lkuBudgetproduksi.vue?vue&type=script&lang=js"
export * from "./lkuBudgetproduksi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports